import { Capacitor } from '@capacitor/core'
import { getPlatforms } from '@ionic/react'
import { useEffect } from 'react'
import useUser from './useUser'

export const useUserInfoUpdater = () => {
	const { user, setUser } = useUser()

	if (Capacitor.getPlatform() === 'web') return // Early return, only update user info on native platforms

	useEffect(() => {
		if (!user || !process.env.REACT_APP_VERSION) return

		const currentVersion = process.env.REACT_APP_VERSION
		const platform = getPlatforms().join(', ')

		if (user.versionNumber !== currentVersion || user.platform !== platform) {
			setUser({
				versionNumber: currentVersion,
				platform,
			})
		}
	}, [user?.versionNumber, user?.platform])
}
